<template>
    <input
        :value="type === 'file' ? '' : val"
        @input="_onInput"
        @change="_onChange"
        v-bind="$props"
        :class="type === 'file' ? '' : 'form-control'"
    >
</template>

<script>
    import input from '../mixins/input';
    export default {
        name: 'VInput',
        mixins: [
            input,
        ],
        props: {
            type: {
                type: String,
                default: 'text',
            },
            name: {
                type: String,
            },
            value: {
                type: [
                    String,
                    Number,
                ],
            },
            placeholder: {
                type: String,
            },
            multiple: {
                type: Boolean,
            },
        },
        data() {
            return {
                val: this.value,
            };
        },
        computed: {
            isNative() {
                return true;
            },
        },
        watch: {
            value(value) {
                this.val = value;
            },
            files(files) {
                if (this.type === 'file') this.$el.files = files;
            },
        },
        methods: {
            _onInput(event) {
                this.val = event.target.value;
                this.$emit('input', event.target.value);
            },
            _onChange(event) {
                if (this.type === 'file') {
                    const files = Array.prototype.reduce.call(event.target.files, (files, file) => {
                        files.push(file);
                        return files;
                    }, []);
                    this.$emit('change', files);
                } else {
                    this.val = event.target.value;
                    this.$emit('change', event.target.value);
                }
            },
        },
    }
</script>